import { useEffect, useState } from 'react'
import { Container, Divider, Grid, Typography, Box } from '@mui/material'
import { Fade } from 'react-reveal'
import { useDispatch, useSelector } from 'react-redux'
import { retrieveSystemAdminRoles, searchRoles } from '../../../../../redux/features/roles/rolesThunk'
import { selectRoles } from '../../../../../redux/features/roles/rolesSlice'
import AddedEmptyRoles from '../../../../../images/emptyRole.png'
import SearchBar from '../../../../../components/PageHelpers/SearchBar'
import { selectSystemAdminUsers } from '../../../../../redux/features/users/SystemAdminUsers/SystemAdminUsersSlice'
import { updateSelectedSystemAdminUserStore } from '../../../../../redux/features/users/SystemAdminUsers/SystemAdminUsersThunk'
import RolesListData from '../../../rolesForm/RolesListData'
import { isNotEmpty } from '../../../../../utils/helpers'
import UseTranslation from '../../../../../hooks/UseTranslation'

const UserStepTwo = ({ setValidStepTwo }) => {
  const dispatch = useDispatch()
  const { updatedUser } = useSelector(selectSystemAdminUsers)
  const userRoles = useSelector(selectRoles)
  const { t } = UseTranslation()
  const [selected, setSelected] = useState([])

  useEffect(() => {
    let selectedRolesClone = []

    Object.values(isNotEmpty(updatedUser?.roles) ? updatedUser?.roles : {})?.forEach(
      (singleRoleContainer) => {
        if (isNotEmpty(singleRoleContainer)) {
          selectedRolesClone = [...selectedRolesClone, ...singleRoleContainer]
        }
      },
    )

    setSelected(selectedRolesClone)
  }, [updatedUser])

  useEffect(() => {
    setValidStepTwo(!selected?.length > 0)
  }, [selected])

  useEffect(() => {
    dispatch(retrieveSystemAdminRoles({
      queries: {
        tenant: updatedUser.tenant_id || updatedUser.company.tenant.id,
        company_id: updatedUser.company.id,
      },
    }))
  }, [dispatch])

  return (
    <Fade bottom>
      <Container maxWidth='xl'>
        <Grid container justify='space-between' sx={styles.root}>
          <Grid item xs={12} sm={8} lg={9} container sx={styles.section}>
            <Grid item xs={12} sx={styles.sectionContainer}>
              <Box sx={{ display: 'block' }}>
                <Typography sx={styles.sectionTitle} variant='h6'>
                  {t?.['Role Information']}
                </Typography>
                <Typography sx={styles.sectionSubTitle} variant='h6'>
                  {t?.['Choose one or more role groups to select user assigned roles']}
                </Typography>
              </Box>
            </Grid>
            <SearchBar
              actionToDispatch={searchRoles}
              searchPlaceholder={t?.['Search for user role']}
              store={userRoles}
              actionProps={{ tenant_id: updatedUser.tenant_id }}
              customStyles={styles.SearchBarContainer}
            />
            <Divider sx={styles.dividerStyle} />

            <Box sx={styles.sectionContent}>
              <Grid item xs={12}>
                <RolesListData condition='recruitment'
                               userStore={updatedUser}
                               actionToDispatch={updateSelectedSystemAdminUserStore}
                               rolesStore={userRoles} />

                <RolesListData condition='eds'
                               userStore={updatedUser}
                               actionToDispatch={updateSelectedSystemAdminUserStore}
                               rolesStore={userRoles} />

                <RolesListData condition='core'
                               userStore={updatedUser}
                               actionToDispatch={updateSelectedSystemAdminUserStore}
                               rolesStore={userRoles} />
                <RolesListData condition='self'
                              userStore={updatedUser}
                              actionToDispatch={updateSelectedSystemAdminUserStore}
                  rolesStore={userRoles} />
                 <RolesListData condition='demo'
                              userStore={updatedUser}
                              actionToDispatch={updateSelectedSystemAdminUserStore}
                  rolesStore={userRoles} />
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4} lg={3} container sx={styles.section}>
            <Box sx={styles.selectedRoles}>
              <Fade right>
                <>
                  <Box sx={styles.selectedRolesTitle}>{t?.['Selected Roles']} ({selected?.length})</Box>
                  {selected?.length !== 0 ? (
                    selected?.map((Roles) => (
                      <Box sx={styles.roles}>
                        {Roles?.display_name ? Roles?.display_name : Roles}
                      </Box>
                    ))
                  ) : (
                    <Box sx={styles.ImageContainer}>
                      <img
                        src={AddedEmptyRoles}
                        alt='empty-roles-art'
                      />
                      <Typography
                      sx={styles.addedEmptyRoleText}>{t?.['Non yet, please select a role']}</Typography>
                    </Box>
                  )}
                </>
              </Fade>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Fade>
  )
}
const styles = {
  root: {
    display: 'flex',
    flexWrap: { xs: 'wrap', sm: 'nowrap' },
    gap: { xs: 'unset', sm: '10px' },
  },
  section: {
    boxShadow: '0 1px 3px 0 #cfd8dc, 0 0 0 1px #f1f1f1',
    display: 'block',
    padding: { xs: '10px', sm: '20px' },
    borderRadius: 5,
    background: '#fff',
    height: '100%',
    marginBottom: { xs: '10px', sm: 'unset' },
  },
  sectionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'baseline', sm: 'normal' },
    p: '5px 10px',
  },
  sectionTitle: {
    fontFamily: 'Avenir 85 Heavy',
    fontWeight: 500,
    fontSize: { xs: '14px', sm: '20px' },
  },
  sectionSubTitle: {
    fontFamily: 'Avenir',
    fontWeight: 500,
    fontSize: { xs: '12px', sm: '16px' },
    lineHeight: 1,
    letterSpacing: 0.1,
    color: '#98A9BC',
    marginTop: '5px',
  },
  SearchBarContainer: {
    m: '10px',
  },
  dividerStyle: {
    marginTop: { xs: '20px', sm: '10px' },
    marginBottom: { xs: '5px', sm: '10px' },
  },
  sectionContent: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'solid 2px #e2e8ee',
      transition: 'all 0.3s ease-in-out',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      paddingTop: 16,
      paddingBottom: 16,
    },
    '& .MuiFormControl-marginDense': {
      marginTop: 22,
      marginBottom: 16,
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px,12px) scale(1)',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      backgroundColor: '#fafbfc',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#29cc8b',
      },
    },
    '& .MuiTypography-root': {
      fontSize: { xs: '10px', sm: '16px' },
    },
    padding: { xs: '8px', sm: '24px 32px 16px' },
    fontSize: { xs: '16px', sm: 'unset' },
  },
  selectedRoles: {
    width: '100%',
    height: '100%',
    padding: { xs: '20px 0px 0px 8px', lg: '20px 10px' },
    borderRadius: '12px',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  selectedRolesTitle: {
    width: '100%',
    lineHeight: 1.3,
    letterSpacing: 'normal',
    margin: { xs: '0 15px 20px 0', sm: '0 15px 20px 0' },
    fontFamily: 'Avenir',
    fontStyle: 'normal',
    fontSize: { xs: '12px', sm: '16px', md: '20px' },
    height: { xs: '20px', sm: '26px' },
    color: '#171725',
    fontStretch: 'normal',
  },
  roles: {
    margin: { xs: '8px 0px 16px 16px', lg: '16px 0px 16px 16px' },
    fontFamily: 'Avenir',
    lineHeight: 1.5,
    letterSpacing: '0.1px',
    color: '#8d8f99',
    fontSize: { xs: '10px', sm: '16px' },
    width: '100%',
    fontStretch: 'normal',
    fontStyle: 'normal',
    height: { xs: '16px', sm: '24px' },
    fontWeight: 500,

  },
  ImageContainer: {
    '& img': {
      display: 'block',
      maxWidth: { xs: '150px', sm: '300px' },
      width: '100%',
      maxHeight: '300px',
      height: '100%',
      margin: 'auto',
    },
  },
  addedEmptyRoleText: {
    lineHeight: 1.2,
    height: 24,
    width: '100%',
    fontStyle: 'normal',
    margin: { xs: '30px 0px 0 0px', lg: '20px 0px 0 0px' },
    textAlign: 'center',
    fontFamily: 'Avenir',
    color: '#171725',
    fontStretch: 'normal',
    fontSize: { xs: '12px', md: '16px' },
    letterSpacing: 'normal',
    fontWeight: 500,
  },
}
export default UserStepTwo
